import { createPending,createSuccess,createFail } from "./userCreateSlice";
import { userCreation } from "../../../api/userApi";
import Swal from "sweetalert2";
export const newUserCreation = (frmDt) => async(dispatch) => {

    try {
        dispatch(createPending());
        console.log(frmDt)
        const result = await userCreation(frmDt);
        
       // console.log("userCreation "+result);
      // console.log("try block");
       //console.log(result.status);
        result.status ==="success" 
        ? dispatch(createSuccess(result.message))
        : dispatch(createFail(result.message));
        
    } catch (error) {
       // console.log("catch block");
        const err= JSON.parse(JSON.stringify(error.response.data.error));
        console.log(err);
        console.log(err.msg);
       // console.log(err.message);
        //console.log(JSON.parse(JSON.stringify(error)));
        dispatch(createFail(error.message));
        Swal.fire(err.msg, '', 'error')
    }
    
}